/**
 * @file useSectionFormSink.ts
 * @description Связь канвы с несохранённой формой секции (phase19.16 Р2;
 * вынесено из `SectionBlockEditor` в партии SB120 этапа 1 без изменения
 * поведения): пока в форме есть правки, текст с канвы идёт в неё, а клик по
 * элементу на канве ищет элемент в ней же (канва рисует форму).
 */

import type { SectionPayload } from "@chaiberi/shared";
import { useEffect, type MutableRefObject } from "react";

import type { FormSink } from "./useBlockActions";
import { applyCanvasText, elementIdAtPath } from "../../lib/site-builder/section-edit";

interface Deps {
  formSink: MutableRefObject<FormSink | null>;
  blockId: string;
  dirty: boolean;
  payload: SectionPayload;
  setPayload: (payload: SectionPayload) => void;
}

export function useSectionFormSink({ formSink, blockId, dirty, payload, setPayload }: Deps): void {
  useEffect(() => {
    formSink.current = {
      blockId,
      dirty,
      applyCanvasText: (path, value) => {
        const next = applyCanvasText(payload, path, value);
        if (next) setPayload(next);
        return next !== null;
      },
      // Канва рисует несохранённую форму — элемент по клику ищем в ней, а не в сохранённом блоке.
      elementIdAt: (path) => elementIdAtPath(payload, path),
    };
    return () => {
      formSink.current = null;
    };
  }, [blockId, dirty, formSink, payload, setPayload]);
}
